import { render, staticRenderFns } from "./TribeName.vue?vue&type=template&id=5b14772b&scoped=true&"
import script from "./TribeName.vue?vue&type=script&lang=ts&"
export * from "./TribeName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b14772b",
  null
  
)

export default component.exports